import React from 'react';

const CustomOptions = ({ 
  dealershipName, 
  onDealershipNameChange,
  customText,
  onCustomTextChange,
  colors,
  onColorsChange
}) => {
  const colorOptions = [
    'Red', 'Blue', 'Black', 'White', 'Silver', 'Gray', 'Gold', 'Green'
  ];

  const handleColorToggle = (color) => {
    const newColors = colors.includes(color)
      ? colors.filter(c => c !== color)
      : [...colors, color];
    onColorsChange(newColors);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-800">Dealership Details</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Dealership Name
          </label>
          <input
            type="text"
            value={dealershipName}
            onChange={(e) => onDealershipNameChange(e.target.value)}
            placeholder="Enter your dealership name"
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <p className="text-sm text-gray-500 mt-1">
            This will be incorporated into the image composition and branding
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Preferred Vehicle Colors
          </label>
          <div className="flex flex-wrap gap-2">
            {colorOptions.map((color) => (
              <button
                key={color}
                onClick={() => handleColorToggle(color)}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  colors.includes(color)
                    ? 'bg-blue-500 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {color}
              </button>
            ))}
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Select preferred colors for the vehicle in the image
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Additional Requirements
          </label>
          <textarea
            value={customText}
            onChange={(e) => onCustomTextChange(e.target.value)}
            placeholder="Any specific requirements, lighting preferences, angles, or details for the image..."
            rows={4}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          />
          <p className="text-sm text-gray-500 mt-1">
            Describe any specific visual requirements or preferences
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomOptions;